/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { useEffect, useState } from 'react';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

import { currencyToNumber } from '@/utils/Formatter';
import { normalizeOtaName } from '@/utils/otaUtils';
import { compareList } from '@/utils/Sorting';

import {
  getReservationGuestDamageNegotiation,
  getReservationGuestDamages,
  postGuestDamage,
  postGuestDamageEvidences,
  postGuestDamageNegotiation,
} from '@/services/GuestDamage/request';
import {
  GetGuestDamageNegotiation,
  GuestDamageItemType,
  GuestDamageResolution,
  GuestDamageType,
} from '@/services/GuestDamage/types';

import { FileProps } from '@/context/FileContext/types';
import { useToast } from '@/context/ToastContext';

import { useFile } from '@/hooks/FileHook/useFile';
import { useGuestDamage } from '@/hooks/GuestDamage/useGuestDamage';
import { useGuestDamageNegotiation } from '@/hooks/GuestDamage/useGuestDamageNegotiation';
import { useGuestDamageStep } from '@/hooks/GuestDamage/useGuestDamageStep';
import { useReservations } from '@/hooks/GuestDamage/useReservations';
import { useMobile } from '@/hooks/useMobile/useMobile';

import { ImageOta } from '@/pages/CriarDano/CriarDano.constants';
import { categoryOptions } from '@/pages/DetailsDamage/components/CreateDamage/constants';

import ImageUpload from '@/components/FileUpload';
import FormButton from '@/components/FormButton/FormButton';
import RadioButton from '@/components/RadioButton';
import SimpleSelect from '@/components/SimpleSelect';
import { SelectOption } from '@/components/SimpleSelect/SimpleSelect';
import { ErrorIcon } from '@/components/TextField/styles';
import TextField from '@/components/TextField/TextField';

import { AddButtonContainer, CardContainerV2, CardHeaderContainer, IconBox } from '../../styles';

import { CalendarIcon, HouseIcon, PlusIcon, UserIcon } from './icons';
import ItemsTable, { ManualError } from './ItemsTable';
import { validation } from './schema';
import {
  AlertText,
  ButtonContainer,
  DamageDetailsHeaderContainer,
  DamageDetailsHeaderItem,
  DamageTypeForm,
  InsertDamageDetailsCardContainer,
  OtaLogo,
} from './styles';

import { captureError } from '@/lib/sentry';

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const InsertDamageDetailsCardV2 = () => {
  const { selectedReservation } = useReservations();
  const { handleViewDamageDetailsStep } = useGuestDamageStep();
  const { setSelectedGuestDamageNegotiation } = useGuestDamageNegotiation();
  const {
    setGuestDamagesToInsert,
    setReservationGuestDamages,
    setIsLoading,
    isLoading,
    quotationFile,
    setQuotationFile,
  } = useGuestDamage();
  const { setReservations } = useReservations();
  const toast = useToast();
  const { createFileReference, uploadFileToS3 } = useFile();

  const { selectedGuestDamageNegotiation } = useGuestDamageNegotiation();

  const [quotationError, setQuotationError] = useState<string | null>(null);

  const { isMobile } = useMobile();

  const today = moment();
  const isLessThanFourteenDaysAfterCheckout =
    today.diff(moment(selectedReservation.check_out_date), 'days') < 14;
  const finishSafeDate = moment(
    selectedReservation?.check_out_date ||
      selectedGuestDamageNegotiation?.reservation?.check_out_date,
  ).add(14, 'days');

  // Helper para capturar erros de forma consistente
  const handleError = (error: unknown, userMessage: string) => {
    toast.error(userMessage);
    captureError({
      error: error as Error,
      module: 'guest_damage_franchise',
      payload: {
        reservation: selectedReservation.id!,
      },
    });
  };

  const needToDoneOptions: SelectOption[] = [
    {
      value: 'Repor item',
      valueLabel: 'Repor item',
    },
    {
      value: 'Conserto',
      valueLabel: 'Conserto',
    },
    {
      value: 'Limpeza',
      valueLabel: 'Limpeza',
    },
    {
      value: 'Contratar Serviço Terceirizado',
      valueLabel: 'Contratar Serviço Terceirizado',
    },
    {
      value: 'Cobrar Pendência',
      valueLabel: 'Cobrar Pendência',
    },
  ].sort((a, b) => compareList(a.valueLabel, b.valueLabel));

  const initialValues = {
    damageType: '',
    resolution: '',
    observation: '',
    quotationLink: '',
    informOwner: 'false',

    items: [
      {
        id: uuid(),
        description: '',
        itemName: '',
        itemType: undefined as GuestDamageItemType | undefined | 'Outro',
        quantity: 1,
        itemPrice: '',
        evidenceFiles: [] as FileProps[],
      },
    ],
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await handleInsertGuestDamageDetails(values);
      } catch (error) {
        console.error('Erro ao inserir danos:', error);
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    const mappedDamages = formik.values.items.map((item) => ({
      id: item.id,
      damage_type: formik.values.damageType as GuestDamageType,
      item_name: item.itemName,
      item_quantity: item.quantity,
      item_price: currencyToNumber(item.itemPrice),
      resolution: formik.values.resolution as GuestDamageResolution,
      reservation: selectedGuestDamageNegotiation.reservation?.id || selectedReservation.id!,
    }));
    setGuestDamagesToInsert(mappedDamages);
  }, [
    formik.values.items,
    formik.values.damageType,
    formik.values.resolution,
    selectedGuestDamageNegotiation.reservation?.id,
    selectedReservation.id,
    setGuestDamagesToInsert,
  ]);

  // Limpar itemName quando a categoria mudar
  useEffect(() => {
    if (formik.values.damageType) {
      formik.values.items.forEach((item, index) => {
        if (item.itemName) {
          formik.setFieldValue(`items.${index}.itemName`, '');
          formik.setFieldValue(`items.${index}.itemType`, undefined);
        }
      });
    }
  }, [formik.values.damageType]);

  const handleGetReservationGuestDamages = async (reservation?: number) => {
    if (reservation) {
      try {
        setIsLoading(true);
        const response = await getReservationGuestDamages(reservation);
        if (response.length > 0) {
          setReservationGuestDamages([...response]);
        }
        setIsLoading(false);
      } catch (err) {
        toast.error('Não foi possível recuperar os danos do hóspede!');
        setIsLoading(false);
      }
    } else {
      toast.error('Não foi possível recuperar os dados de negociação do dano!');
    }
  };

  async function connectGuestDamageWithNegotiation() {
    try {
      let data: GetGuestDamageNegotiation | undefined;
      if (!selectedGuestDamageNegotiation.id) {
        data = await postGuestDamageNegotiation({
          reservation: selectedReservation.id!,
          stage: 'Detalhes do dano',
          status: 'Tratativa passou para o atendimento',
          is_to_inform_owner: formik.values.informOwner === 'true',
        });
        toast.success('A tratativa passou para o atendimento.');
        if (data) {
          setSelectedGuestDamageNegotiation({
            ...data,
            reservation: { ...selectedReservation },
          });
          handleGetReservationGuestDamages(data.reservation as number);
        }
      } else {
        handleGetReservationGuestDamages(selectedGuestDamageNegotiation.id);
      }
      setGuestDamagesToInsert([]);
      setReservations([]);
      handleViewDamageDetailsStep();
    } catch (e: any) {
      let errorMessage = 'Erro ao criar tratativa de dano.';
      let isNegotiationAlreadyExists = false;

      // Verifica tanto e.detail.reservation quanto e.response.data.reservation
      const reservationError = e?.detail?.reservation || e?.response?.data?.reservation;

      if (reservationError) {
        // Verifica especificamente o erro de negociação duplicada
        if (
          Array.isArray(reservationError) &&
          (reservationError[0]?.includes('already exists') ||
            reservationError[0]?.includes(
              'guest damage negotiation with this reservation already exists',
            ))
        ) {
          // Negociação já existe - não é um erro real, apenas adiciona os danos
          isNegotiationAlreadyExists = true;
        } else {
          errorMessage = Array.isArray(reservationError) ? reservationError[0] : reservationError;
        }
      } else if (e instanceof Error) {
        errorMessage = e.message;
      }

      // Só mostra toast de erro se NÃO for o caso de negociação duplicada
      if (!isNegotiationAlreadyExists) {
        toast.error(errorMessage);
      }

      captureError({
        error: e,
        module: 'guest_damage_franchise',
        payload: {
          reservation: selectedReservation.id!,
        },
      });

      // Se a negociação já existe, os danos foram criados com sucesso
      // Então navegamos para a tela de visualização
      if (isNegotiationAlreadyExists) {
        // Busca a negociação existente para popular os dados de cabeçalho
        const existingNegotiation = await getReservationGuestDamageNegotiation(
          selectedReservation.id!,
        );

        // Define a negociação existente no contexto
        if (existingNegotiation) {
          setSelectedGuestDamageNegotiation({
            ...existingNegotiation,
            reservation: { ...selectedReservation },
          });
        }

        // Carrega os danos antes de navegar
        await handleGetReservationGuestDamages(selectedReservation.id!);
        setGuestDamagesToInsert([]);
        setReservations([]);
        handleViewDamageDetailsStep();
        return; // Não re-lança o erro neste caso
      }

      // Re-lança o erro para outros tipos de erro
      throw e;
    }
  }

  async function handleInsertGuestDamageDetails(values: typeof initialValues) {
    if (values.items.length === 0) {
      toast.error('Adicione pelo menos um item para enviar o formulário');
      return;
    }

    const hasInvalidItems = values.items.some(
      (item) => !item.evidenceFiles || item.evidenceFiles.length === 0,
    );

    if (hasInvalidItems) {
      toast.error('Todos os itens devem ter uma evidência (link ou foto)!');
      return;
    }

    // Validação de orçamento/NF: deve ter pelo menos um link OU arquivo
    const hasQuotationLink = values.quotationLink?.trim();
    const hasQuotationFile = quotationFile?.uid || quotationFile?.id || quotationFile?.file;

    if (!hasQuotationLink && !hasQuotationFile) {
      setQuotationError('Forneça um link OU faça upload do orçamento/NF');
      return;
    }

    // Limpar erro se validação passar
    setQuotationError(null);
    try {
      setIsLoading(true);

      let uploadedQuotationUid: string | undefined = quotationFile?.uid;

      if (quotationFile?.file && !quotationFile?.uid) {
        try {
          const fileReference = await createFileReference({
            name: quotationFile.name,
            category: 'document',
            content_type: quotationFile.MIMEtype,
          });

          await uploadFileToS3(quotationFile, {
            file: quotationFile.file,
            fileId: fileReference.uid,
            url: fileReference.storage.url,
            fields: fileReference.storage.fields,
            key: fileReference.storage.fields.key,
            acl: fileReference.storage.fields.acl,
            content_type: quotationFile.MIMEtype,
            policy: fileReference.storage.fields.policy,
            signature: fileReference.storage.fields.signature,
            AWSAccessKeyId: fileReference.storage.fields.AWSAccessKeyId,
          });

          uploadedQuotationUid = fileReference.uid;
        } catch (error) {
          handleError(error, 'Erro ao fazer upload do arquivo de orçamento ou NF');
        }
      }

      // 2. Processar cada item: fazer upload das evidências e criar os danos
      const promises = values.items.map(async (item) => {
        try {
          const evidenceUids: string[] = [];

          // Upload de todos os arquivos de evidência
          if (item.evidenceFiles && item.evidenceFiles.length > 0) {
            for (const evidenceFile of item.evidenceFiles) {
              if (evidenceFile?.file && !evidenceFile?.uid) {
                try {
                  const fileReference = await createFileReference({
                    name: evidenceFile.name,
                    category: 'document',
                    content_type: evidenceFile.MIMEtype,
                  });

                  await uploadFileToS3(evidenceFile, {
                    file: evidenceFile.file,
                    fileId: fileReference.uid,
                    url: fileReference.storage.url,
                    fields: fileReference.storage.fields,
                    key: fileReference.storage.fields.key,
                    acl: fileReference.storage.fields.acl,
                    content_type: evidenceFile.MIMEtype,
                    policy: fileReference.storage.fields.policy,
                    signature: fileReference.storage.fields.signature,
                    AWSAccessKeyId: fileReference.storage.fields.AWSAccessKeyId,
                  });

                  evidenceUids.push(fileReference.uid);
                } catch (error) {
                  handleError(error, `Erro ao fazer upload da evidência do item: ${item.itemName}`);
                }
              } else if (evidenceFile?.uid) {
                evidenceUids.push(evidenceFile.uid);
              }
            }
          }

          // Criar o registro do dano
          const createdGuestDamage = await postGuestDamage({
            reservation: selectedGuestDamageNegotiation.reservation?.id || selectedReservation.id!,
            damage_type: values.damageType as GuestDamageType,
            item_type: item.itemType === 'Outro' ? undefined : item.itemType,
            item_name: item.itemName,
            item_quantity: item.quantity,
            resolution: values.resolution as GuestDamageResolution,
            description: item.description,
            item_price: currencyToNumber(item.itemPrice),
            observation: values.observation,
            quotation_file: uploadedQuotationUid,
            quotation_link: values.quotationLink || undefined,
          });

          // Postar todas as evidências
          for (const evidenceUid of evidenceUids) {
            await postGuestDamageEvidences(createdGuestDamage.id as number, evidenceUid);
          }

          return createdGuestDamage;
        } catch (e) {
          if (e instanceof Error) {
            handleError(e, 'Aconteceu um erro inesperado');
          }
        }
      });

      await Promise.all(promises);
      await connectGuestDamageWithNegotiation();
      toast.success('Os danos foram inseridos com sucesso!');
    } catch (e: any) {
      // Verifica se é um erro de negociação (já tratado em connectGuestDamageWithNegotiation)
      const isNegotiationError = e?.detail?.reservation || e?.response?.data?.reservation;

      // Se não for erro de negociação, mostra erro genérico
      if (!isNegotiationError && e instanceof Error) {
        handleError(e, 'Aconteceu um erro inesperado');
      }
    } finally {
      setQuotationFile({} as FileProps);
      formik.resetForm();
      setIsLoading(false);
    }
  }

  const currentOtaName =
    selectedReservation.ota_name || selectedGuestDamageNegotiation.reservation?.ota_name || '';

  return (
    <FormikProvider value={formik}>
      <div style={{ display: 'flex', gap: '16px', flexDirection: 'column', overflow: 'auto' }}>
        <CardHeaderContainer>
          <DamageDetailsHeaderContainer>
            <DamageDetailsHeaderItem>
              <IconBox>
                <HouseIcon />
              </IconBox>
              <div>
                <h3>Propriedade</h3>
                <p>
                  {selectedReservation.property_code ||
                    selectedGuestDamageNegotiation.reservation?.property_code}
                </p>
              </div>
            </DamageDetailsHeaderItem>

            <DamageDetailsHeaderItem>
              <IconBox>
                <UserIcon />
              </IconBox>
              <div>
                <h3>Hóspede</h3>
                <p>
                  {selectedReservation.guest_name ||
                    selectedGuestDamageNegotiation.reservation?.guest_name}
                </p>
              </div>
            </DamageDetailsHeaderItem>

            <DamageDetailsHeaderItem>
              <IconBox>
                <CalendarIcon />
              </IconBox>
              <div>
                <h3>Checkout</h3>
                <p>
                  {moment(selectedReservation.check_out_date).format('DD/MM/YYYY') ||
                    moment(selectedGuestDamageNegotiation.reservation?.check_out_date).format(
                      'DD/MM/YYYY',
                    )}
                </p>
              </div>
            </DamageDetailsHeaderItem>
            <DamageDetailsHeaderItem>
              <OtaLogo>
                {currentOtaName &&
                ImageOta[normalizeOtaName(currentOtaName) as keyof typeof ImageOta] ? (
                  <img
                    src={
                      ImageOta[
                        normalizeOtaName(currentOtaName) as keyof typeof ImageOta
                      ] as unknown as string
                    }
                    alt={currentOtaName}
                    style={{ width: '58px', height: 'auto' }}
                  />
                ) : (
                  <span style={{ fontSize: '12px', fontWeight: '500' }}>
                    {currentOtaName || '-'}
                  </span>
                )}
              </OtaLogo>
            </DamageDetailsHeaderItem>
          </DamageDetailsHeaderContainer>
        </CardHeaderContainer>

        {selectedReservation.ota_name === 'Airbnb' && (
          <div
            style={{
              padding: '4px',
              border: '1px #DA1E28',
              color: '#DA1E28',
              width: '100%',
              display: 'flex',
            }}
          >
            <ErrorIcon />

            <AlertText>
              {isLessThanFourteenDaysAfterCheckout
                ? `Atenção! O atendimento tem até o dia ${finishSafeDate.format('DD/MM/YYYY')} para solicitar o pedido de reembolso com seguro pela plataforma`
                : 'Atenção! O prazo para realizar o pedido de reembolso com seguro pela plataforma já expirou! O Atendimento prosseguirá com a cobrança sem o respaldo do Aircover, sem garantia de sucesso!'}
            </AlertText>
          </div>
        )}

        <CardContainerV2>
          <h3>Tipo de Problema</h3>

          <SimpleSelect
            id="damageType"
            options={categoryOptions}
            placeholder={'Selecione a categoria geral'}
            label="Categoria"
            labelClassName="label"
            formik={formik}
            onChange={(e) => {
              formik.handleChange(e);
              setTimeout(() => {
                formik.setFieldTouched('damageType', true);
                formik.validateField('damageType');
              }, 0);
            }}
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h3>Itens Danificados</h3>
            {!isMobile && (
              <FieldArray
                name="items"
                render={(arrayHelpers) => (
                  <AddButtonContainer
                    type="button"
                    onClick={() =>
                      arrayHelpers.push({
                        id: uuid(),
                        description: '',
                        itemName: '',
                        itemPrice: '',
                        quantity: 1,
                        itemType: undefined,
                        other: '',
                        evidenceFiles: [],
                      })
                    }
                  >
                    <PlusIcon />
                    Adicionar Item
                  </AddButtonContainer>
                )}
              />
            )}
          </div>

          <ItemsTable category={formik.values.damageType} formik={formik} />
        </CardContainerV2>

        <CardContainerV2>
          <h3>Detalhes</h3>
          <InsertDamageDetailsCardContainer>
            <DamageTypeForm onSubmit={formik.handleSubmit}>
              <FormGrid>
                <SimpleSelect
                  id="resolution"
                  options={needToDoneOptions}
                  placeholder={'Selecione'}
                  label="O que precisa ser feito? *"
                  labelClassName="label"
                  formik={formik}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setTimeout(() => {
                      formik.setFieldTouched('resolution', true);
                      formik.validateField('resolution');
                    }, 0);
                  }}
                />

                <RadioButton
                  id="informOwner"
                  formLabel="Informar Proprietário"
                  labelPlacement="end"
                  options={[
                    { value: 'true', label: 'Sim' },
                    { value: 'false', label: 'Não' },
                  ]}
                  formik={formik}
                />

                <div>
                  <TextField
                    id="quotationLink"
                    placeholder="Digite aqui..."
                    value={formik.values.quotationLink}
                    label="Link do Orçamento ou NF"
                    labelClassName="label"
                    onChange={(e) => {
                      formik.handleChange(e);
                      // Limpar erro ao digitar
                      if (quotationError) {
                        setQuotationError(null);
                      }
                    }}
                    onBlur={() => {
                      formik.setFieldTouched('quotationLink', true);
                      formik.validateField('quotationLink');
                    }}
                    error={formik.touched.quotationLink && !!formik.errors.quotationLink}
                    formik={formik}
                  />

                  {quotationError && <ManualError message={quotationError as string} />}
                </div>

                <div>
                  <label style={{ marginBottom: '8px', display: 'block' }} className="label">
                    Upload do Orçamento ou NF
                  </label>

                  <ImageUpload
                    name="quotationFile"
                    formik={formik}
                    maxSize={5}
                    multiple={false}
                    acceptedTypes={['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                    existingFiles={quotationFile?.name ? [quotationFile] : []}
                    onRemoveFile={() => {
                      setQuotationFile({} as FileProps);
                      formik.setFieldValue('quotationFile', null);
                    }}
                    onUploadFile={(uploadedFiles: File[]) => {
                      const nativeFile = uploadedFiles[0];
                      if (nativeFile) {
                        const fileProps: FileProps = {
                          id: uuid(),
                          uid: undefined,
                          file: nativeFile,
                          name: nativeFile.name,
                          size: nativeFile.size,
                          readableSize: `${(nativeFile.size / 1024).toFixed(2)} KB`,
                          MIMEtype: nativeFile.type,
                          previewURL: URL.createObjectURL(nativeFile),
                          url: null,
                          uploadProgress: 0,
                          uploaded: false,
                          error: false,
                          content_type: nativeFile.type,
                          originalFile: nativeFile,
                          type: nativeFile.type,
                        };
                        setQuotationFile(fileProps);
                        formik.setFieldValue('quotationFile', fileProps);
                        // Limpar erro ao fazer upload
                        if (quotationError) {
                          setQuotationError(null);
                        }
                        return [fileProps];
                      }
                      return [];
                    }}
                  />
                </div>
              </FormGrid>
            </DamageTypeForm>
          </InsertDamageDetailsCardContainer>
        </CardContainerV2>

        <ButtonContainer>
          <FormButton
            onClick={() => {
              // Validação prévia: verificar se há itens antes do Formik validar
              if (formik.values.items.length === 0) {
                toast.error('Adicione pelo menos um item para enviar o formulário');
                return;
              }
              formik.handleSubmit();
            }}
            type="button"
            disable={isLoading}
          >
            Criar Dano
          </FormButton>
        </ButtonContainer>
      </div>
    </FormikProvider>
  );
};
